import { useIsomorphicEffect } from '@ocodelib/mui/hooks';
import type { IProjectLoader, ProjectFile } from '@repo/project-interface';
import { useEffect, useMemo, useState } from 'react';
import type { P5BasicAppType } from '../types';
import { createP5BasicApp } from './create-app';

export function useP5BasicAppLoader(options: {
  previewMode: boolean;
  newProjectLoader?: IProjectLoader<ProjectFile[]>;
  initialProjectLoader?: IProjectLoader<ProjectFile[]>;
}) {
  const { previewMode, newProjectLoader, initialProjectLoader } = options;
  const [app, setApp] = useState<P5BasicAppType | undefined>();
  const [enabled, setEnabled] = useState(false);

  useIsomorphicEffect(() => {
    setEnabled(true);
    return () => {
      setEnabled(false);
    };
  }, []);

  useIsomorphicEffect(() => {
    if (!enabled || !app) return;
    return () => {
      app.destroy();
      setApp(undefined);
    };
  }, [enabled, app]);

  useEffect(() => {
    if (!enabled) return;
    if (app) {
      // console.log("app already defined");
      return;
    }
    const ctx = { canceled: false };
    createP5BasicApp({ ctx, previewMode, newProjectLoader, initialProjectLoader }, setApp);
    return () => {
      ctx.canceled = true;
    };
  }, [enabled, previewMode, app, newProjectLoader, initialProjectLoader]);

  return useMemo(
    () => ({
      app,
    }),
    [app],
  );
}
